/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PersistedEmailItemResp } from '../models/persisted-email-item-resp';

@Injectable({
  providedIn: 'root',
})
export class PersistedEmailService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiPersistedEmailLasted100Get
   */
  static readonly ApiPersistedEmailLasted100GetPath = '/api/PersistedEmail/lasted-100';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiPersistedEmailLasted100Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPersistedEmailLasted100Get$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PersistedEmailItemResp>>> {

    const rb = new RequestBuilder(this.rootUrl, PersistedEmailService.ApiPersistedEmailLasted100GetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PersistedEmailItemResp>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiPersistedEmailLasted100Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiPersistedEmailLasted100Get(params?: {
  }): Observable<Array<PersistedEmailItemResp>> {

    return this.apiPersistedEmailLasted100Get$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PersistedEmailItemResp>>) => r.body as Array<PersistedEmailItemResp>)
    );
  }

}
